interface Scripts {
  name: string;
  src: string;
}

export const SCRIPT_NAMES = {
  GOOGLE_MAPS: 'googlemaps'
};

export const SCRIPT_STORE: Scripts[] = [
  {
    name: SCRIPT_NAMES.GOOGLE_MAPS,
    src: 'https://maps.googleapis.com/maps/api/js?libraries=places'
  }
];
